// extracted by mini-css-extract-plugin
export default {"overlay":"menu_overlay__RRi0Y","open":"menu_open__usPNc","bgPan":"menu_bgPan__uLVeI"};